module.exports = require('./helpers/bundle-url').getBundleURL('4afSR') + "Building_Images.081b9b6a.png";